/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ServiceProviderVoModel } from './service-provider-vo.model';
import { RoutingSolutionViewModel } from './routing-solution-view.model';
import { CurrencyValueModel } from './currency-value.model';
import { OfferVO } from './offer-vo.model';

export class OfferFromOfferRequestModel extends JSONable {
  uuid: string | undefined = undefined;
  offerRequestNumber: string | undefined = undefined;
  numberOfShipments: number | undefined = undefined;
  numberOfGroups: number | undefined = undefined;
  numberOfRoutingSolutions: number | undefined = undefined;
  progress: number | undefined = undefined;
  requestDate: string | undefined = undefined;
  deadline: string | undefined = undefined;
  serviceProviders: Array<ServiceProviderVoModel> | undefined = undefined;
  routingSolutions: Array<RoutingSolutionViewModel> | undefined = undefined;
  offersPreview: Array<OfferVO> | undefined = undefined;
  totalCost: number | undefined = undefined;
  price: CurrencyValueModel | undefined = undefined;
  details: string | undefined = undefined;
}
